import React, { useContext } from 'react';
import { UnitsContext } from '../../../../Contexts/UnitsContext';

import { getExperimentSplitInfoOfSection } from './helpers';
import { getSectionNameToDisplay } from '../SiteConfig/ExperimentsContextSettings/helpers';
import { experimentInfoPrefixStyle } from './styles';

//mui imports====
import ArchiveIcon from '@mui/icons-material/Archive';

export const ExperimentInfoPrefix = ({ prefix }) => <span style={experimentInfoPrefixStyle}>{prefix}</span>;

// Function to get the Archive Icon for Video Section Unit
const getArchiveIcon = (sectionRef, units) => {
	if (units[sectionRef]?.isArchived) {
		return (
			<ArchiveIcon
				fontSize="small"
				style={{ color: 'red', marginRight: '0.5rem', verticalAlign: 'middle' }}
			/>
		);
	}

	return null;
};

// Helper to render unit label with split info and archive icon
export const UnitLabel = ({ unitData }) => {
    const { units, sectionLevelSplit } = useContext(UnitsContext);

    const splitInfo = getExperimentSplitInfoOfSection(sectionLevelSplit, unitData, units);
    const archiveIcon = getArchiveIcon(unitData.sectionRef, units);
    const sectionName = getSectionNameToDisplay(unitData);

    return (
        <>
            {splitInfo ? <ExperimentInfoPrefix prefix={splitInfo} /> : null}
            {archiveIcon} {sectionName} ({unitData.videoSectionId})
        </>
    );
};

export default UnitLabel;